/**
 * Simplified browser-only logger for sharelib file-uploader
 * Replaces pivot-shared/logger
 */

var createLogger = function createLogger(name) {
  var prefix = typeof name === 'string' ? name : 'file-uploader';
  return {
    debug: function debug() {
      if (typeof window !== 'undefined' && window.localStorage && window.localStorage.debugLevel === 'debug') {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (_console = console).debug.apply(_console, ["[".concat(prefix, "]")].concat(args));
      }
    },
    info: function info() {
      var _console2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return (_console2 = console).info.apply(_console2, ["[".concat(prefix, "]")].concat(args));
    },
    warn: function warn() {
      var _console3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return (_console3 = console).warn.apply(_console3, ["[".concat(prefix, "]")].concat(args));
    },
    error: function error() {
      var _console4;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return (_console4 = console).error.apply(_console4, ["[".concat(prefix, "]")].concat(args));
    },
    trace: function trace() {
      var _console5;
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return (_console5 = console).trace.apply(_console5, ["[".concat(prefix, "]")].concat(args));
    }
  };
};

// Support both logger.createLogger() and logger() patterns
createLogger.createLogger = createLogger;
export default createLogger;
export { createLogger };